
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./UserInfo": () => {
return __webpack_require__.e("src_UserInfo_tsx").then(() => (() => (__webpack_require__("./src/UserInfo.tsx"))));
},
"./theme": () => {
return __webpack_require__.e("src_theme_css").then(() => (() => (__webpack_require__("./src/theme.css"))));
},
"./utils": () => {
return __webpack_require__.e("src_utils_ts").then(() => (() => (__webpack_require__("./src/utils.ts"))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };